// extracted by mini-css-extract-plugin
export default {"container":"Fi-z","modal":"Gi-z"};